export default __webpack_public_path__ + "static/media/Background_00245.ebe82055.png";